import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { Button } from "semantic-ui-react";
import PropTypes from "prop-types";

@observer
class TourbuzzLoginAd extends Component {
  render() {
    const { t } = this.props;

    return (
      <div className="ad">
        <h2 className="login-ad-heading">
          Get a free Insta360 X4 Camera! <br />
          <strong>
            Trivaxis Capture is now compatible with Insta360 cameras!
          </strong>
        </h2>

        <img
          src="https://storage.googleapis.com/biz-website/images/tourbuzz_login_promo_insta360.jpg"
          alt="Promo Insta360"
        />

        <div className="login-ad-action-btn">
          Provide a realistic and immersive online experience covering the interior of any space. Boost online
          engagement and put buyers inside your listings any time, anywhere - a 24/7 open house! Discover our 3D & 2D
          product and offer!
        </div>

        <Button.Group>
          <Button href="https://www.tourbuzz.com/insta360" target="_blank">
            {t("login:learnMore")}
          </Button>
          <Button primary href="https://www.tourbuzz.com/insta360#contact-form" target="_blank">
            Take advantage of this offer
          </Button>
        </Button.Group>
      </div>
    );
  }
}

TourbuzzLoginAd.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TourbuzzLoginAd);
